import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response || error.message);
    alert("API Error: " + (error.response?.data?.detail || error.message));
    return Promise.reject(error);
  }
);

export default api;

// NDJSON streaming helper for transcript parsing
export async function streamParseTranscript(
  file,
  { onTurn, onFinal, onError } = {}
) {
  try {
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${API_BASE_URL}/parse-transcript-stream`, {
      method: "POST",
      body: form,
    });
    if (!res.ok || !res.body) {
      const text = await res.text().catch(() => "");
      throw new Error(text || `Stream error: ${res.status}`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf("\n")) >= 0) {
        const line = buffer.slice(0, idx).trim();
        buffer = buffer.slice(idx + 1);
        if (!line) continue;
        try {
          const msg = JSON.parse(line);
          if (msg.type === "turn" && msg.turn && onTurn) onTurn(msg.turn);
          else if (msg.type === "final" && onFinal) onFinal(msg);
          else if (msg.type === "error" && onError)
            onError(new Error(msg.detail || "stream error"));
        } catch (e) {
          // ignore partial/keepalive lines
        }
      }
    }
  } catch (err) {
    if (onError) onError(err);
    else alert(`Stream failed: ${err.message}`);
  }
}
